import { Controller } from '@hotwired/stimulus'
import { EnableButtonLoading } from '../shared/utils/loading_button.js'

// Connects to data-controller="loading-button"
export default class extends Controller {
  setButtonLoading(event) {
    EnableButtonLoading(event.currentTarget)
  }
}
